import React from 'react'
import InventiveForm from "../components/InventiveForm"
import Navbar from '../../../components/Navbar'
import Footer from '../../../components/footer'
const InventivePage = () => {
  return (
    <div  >
        <Navbar/>
      <InventiveForm/>
      <Footer/>
    </div>
  )
}

export default InventivePage
